import { WIDGET_VIEW_DATE_TIME } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DateTimeViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_DATE_TIME,
  component: () => import("./date-time-view-widget.component").then((m) => m.DateTimeViewWidgetComponent)
};
